import { API6_ERROR, createLocaleQuery } from './index'

export const getApi6ErrorCode = (result) => {
  return result && result.code === API6_ERROR && result.internalError.code
}

export const createLocaleInApiQuery = (locale: string) =>
  locale ? `?${createLocaleQuery(locale)}` : ''
